<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('发布内容')" prop="videoContent">
                <a-input v-model="queryParam.videoContent" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('发布内容')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">

              <a-form-item :label="$t('状态')" prop="videoState">
                <a-select  :placeholder="$t('通用.输入.请选择')+$t('状态')"
                           @change="orderStatusListChange"
                           style="width: 100%" v-model="queryParam.videoState" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.VideoStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">

              <a-form-item :label="$t('类型')" prop="videoState">
                <a-select  :placeholder="$t('通用.输入.请选择')+$t('类型')"
                           @change="orderStatusListChange"
                           style="width: 100%" v-model="queryParam.videoType" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.VideoTypeEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否置顶')" prop="videoState">
                <a-select  :placeholder="$t('通用.输入.请选择')+$t('是否指定')"
                           style="width: 100%" v-model="queryParam.topFlag" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.YesNoStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('分类')">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('分类')"
                          style="width: 100%" v-model="queryParam.videoPid" allowClear>
                  <a-select-option v-for="(item, index) in categoryOptions" :value="String(item.id)"
                                   :key="index">
                    {{ item.classifyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>


            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal v-if="previewImageVisible" :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
        <a-modal
          v-if="previewVideoVisible"
          :visible="previewVideoVisible"
          :footer="null"
          :width="720"
          @cancel="previewVideoCancel"
        >
          <video
            v-if="previewVideoVisible"
            :src="previewVideoUrl"
            controls
            autoplay
            style="width: 100%; max-height: 70vh; background: #000;"
          />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="openCreateForm('add')" v-hasPermi="['video:video:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['video:video:edit']">-->
        <!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:video:remove']">-->
        <!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['video:video:export']">-->
        <!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        v-if="createFormVisible"
        ref="createForm"
        @ok="getList"
        @close="createFormVisible = false"
      />
      <!-- 评论列表弹窗 -->
      <discuss-list ref="discussList" @ok="getList"></discuss-list>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="videoContent" slot-scope="text, record" style="white-space: pre-wrap; word-break: break-word; text-align: left; display: block;">
          {{ record.videoContent || '-' }}
        </span>
        <span slot="videoPic" slot-scope="text, record">
          <img v-if="getCover(record)" :src="getCover(record)" alt="封面"
            style="width: 80px; height: 80px; object-fit: cover; cursor: pointer;"
            @click="handleRecordPreview(getCover(record))" />
          <span v-else>-</span>
        </span>
        <span slot="videoUrl" slot-scope="text, record">
          <div v-if="record.videoUrl" style="display: flex; flex-wrap: wrap; gap: 8px; justify-content: center;">
            <template v-for="(item, index) in getMediaList(record.videoUrl)">
              <div :key="'media_' + index" style="position: relative;">
                <img
                  v-if="isImage(item)"
                  :src="getThumbUrl(item)"
                  loading="lazy"
                  style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                  @click="handleRecordPreview(item)"
                />
                <video
                  v-else
                  :key="'video_' + item"
                  :src="item"
                  :poster="getThumbUrl(item)"
                  autoplay
                  muted
                  loop
                  playsinline
                  preload="metadata"
                  controls
                  style="width: 120px; height: 80px; object-fit: cover; border-radius: 4px; background: #000; cursor: pointer;"
                  @click="handleRecordPreview(item)"
                  @dblclick="openVideoNewTab(item)"
                />
                <span
                  v-if="index === maxMediaShow - 1 && getMediaCount(record.videoUrl) > maxMediaShow"
                  style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.5); color: #fff; border-radius: 4px; font-size: 14px; cursor: pointer;"
                  @click="handleRecordPreview(record.videoUrl.split(',')[maxMediaShow])"
                >
                  +{{ getMediaCount(record.videoUrl) - maxMediaShow }}
                </span>
              </div>
            </template>
          </div>
          <span v-else>-</span>
        </span>
        <span slot="videoState" slot-scope="text, record">
           <custom-dict-tag :options="customDict.VideoStatusEnum" :value="record.videoState"/>
        </span>
        <span slot="videoType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.VideoTypeEnum" :value="record.videoType"/>
        </span>
        <span  slot="topFlag" slot-scope="text, record">
          <a-switch @change="(checked) => onTopChange(checked,record)" :checked-children="$t('是')"
                    :un-checked-children="$t('否')" :checked="record.topFlag"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="openCreateForm('update', record, undefined)" v-hasPermi="['video:video:edit']">
             <a-icon type="param" />{{$t('通用.按钮.详情')}}
          </a>
          <template v-if="record.videoState !== '3'">
            <a-divider type="vertical" />
            <a @click="handleAuditPass(record)">
              <a-icon type="check" />{{$t('审核通过')}}
            </a>
            <a-divider type="vertical" />
            <a @click="handleAuditReject(record)">
              <a-icon type="close" />{{$t('拒绝')}}
            </a>
          </template>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
          <a-divider type="vertical" />
          <a @click="discussList(record)">
            <a-icon type="message" />{{$t('查看评论')}}
          </a>
        </span>
        <span slot="message" slot-scope="text, record" style="white-space: pre-wrap; word-break: break-word; text-align: left; display: block;">
          {{ record.message || '-' }}
        </span>
        <span slot="classifyName" slot-scope="text, record">
          {{ getCategoryName(record.videoPid) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVideo,listVideo, delVideo ,updateVideoTop, updateVideo } from '@/api/video/video'
import { listRecommendCategory } from '@/api/video/recommendCategory'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import discussList from './discussList'
import { tableMixin } from '@/store/table-mixin'
import {updateUserStatus} from "@/api/biz/user";

export default {
  name: 'Video',
  components: {
    CustomDictTag,
    CreateForm,
    discussList
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 视频播放弹窗
      previewVideoVisible: false,
      previewVideoUrl: '',
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 论坛分类选项
      categoryOptions: [],
      // 媒体内容列最多展示的媒体数量（超出显示 +N），避免图片过多导致列表卡顿
      maxMediaShow: 6,
      // 新增/编辑弹框是否挂载（v-if 控制，关闭即销毁，避免富文本影响列表页）
      createFormVisible: false,
      // 发表寄语弹窗
      messageVisible: false,
      messageLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      currentRecord: {},
      messageForm: {
        id: undefined,
        message: undefined
      },
      messageRules: {
        message: []
      },
      // 查询参数
      queryParam: {
        videoContent: undefined,
        videoPid: undefined,
        videoState: undefined,
        address: undefined,
        pubCity: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '封面',
          dataIndex: 'videoPic',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'videoPic' }
        },
        {
          title: this.$t('发布内容'),
          dataIndex: 'videoContent',
          align: 'center',
          width: 240,
          scopedSlots: { customRender: 'videoContent' }
        },
        {
          title: this.$t('媒体内容'),
          dataIndex: 'videoUrl',
          align: 'center',
          width: 240,
          scopedSlots: { customRender: 'videoUrl' }
        },
        // {
        //   title: this.$t('视频播放地址'),
        //   dataIndex: 'videoUrl',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '审核状态',
          dataIndex: 'videoState',
          scopedSlots: { customRender: 'videoState' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('类型'),
          dataIndex: 'videoType',
          scopedSlots: { customRender: 'videoType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('点赞次数'),
          dataIndex: 'likeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('分享次数'),
          dataIndex: 'shareNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否置顶'),
          dataIndex: 'topFlag',
          scopedSlots: { customRender: 'topFlag' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('视频商品分类id'),
        //   dataIndex: 'videoPid',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('评论数量'),
          dataIndex: 'replyNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('分类'),
          dataIndex: 'classifyName',
          align: 'center',
          scopedSlots: { customRender: 'classifyName' }
        },

        // 发布地址、详细地址不在列表展示，移至详情弹窗
        // {
        //   title: this.$t('发布地址'),
        //   dataIndex: 'address',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: function (v) {
        //     if (v == "" ||v==null) {
        //       return "--";
        //     }else {
        //       return v;
        //     }
        //   }
        // },
        // {
        //   title: this.$t('详细地址'),
        //   dataIndex: 'pubCity',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: function (v) {
        //     if (v == "" ||v==null) {
        //       return "--";
        //     }else {
        //       return v;
        //     }
        //   }
        // },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width:'10%',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getCategoryList()
    this.getList()
  },
  // keep-alive 复用组件时 created 不会再次执行，这里保证每次进入页面都重新加载列表
  activated () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    /** 打开新增/编辑弹框（v-if 延迟创建组件，确保 DOM 已挂载再调用内部方法） */
    openCreateForm (action, record, ids) {
      this.createFormVisible = true
      this.$nextTick(() => {
        if (action === 'update') {
          this.$refs.createForm.handleUpdate(record, ids)
        } else {
          this.$refs.createForm.handleAdd()
        }
      })
    },
    /** 加载论坛分类列表 */
    getCategoryList () {
      listRecommendCategory({}).then(response => {
        this.categoryOptions = response.data || []
      })
    },
    /** 根据 videoPid 获取论坛分类名称 */
    getCategoryName (videoPid) {
      if (!videoPid) {
        return '-'
      }
      const item = this.categoryOptions.find(c => String(c.id) === String(videoPid))
      return item ? item.classifyName : '-'
    },
    //动态评价
    discussList(record) {
      this.$refs.discussList.title = "评论列表";
      this.$refs.discussList.show(record);
    },
    onTopChange(topFlag, record){
      let data = {id: record.id, topFlag: topFlag}
      updateVideoTop(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.topFlag = topFlag
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    isImage(url) {
      if (!url) return false
      const lower = url.toLowerCase().split('?')[0]
      return lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png') || lower.endsWith('.gif') || lower.endsWith('.webp') || lower.endsWith('.bmp')
    },
    getCover(record) {
      if (record.videoPic) return record.videoPic
      const media = Array.isArray(record.videoUrlList) && record.videoUrlList.length
        ? record.videoUrlList : (record.videoUrl || '').split(',').filter(Boolean)
      const first = media[0]
      if (!first) return ''
      return String(record.videoType) === '1' || this.isImage(first) ? first : this.getThumbUrl(first)
    },
    /** 媒体总数 */
    getMediaCount(videoUrl) {
      if (!videoUrl) return 0
      return videoUrl.split(',').filter(Boolean).length
    },
    /** 需要渲染的媒体列表（超出 maxMediaShow 截断，最后一张位置用于显示 +N） */
    getMediaList(videoUrl) {
      if (!videoUrl) return []
      const list = videoUrl.split(',').filter(Boolean)
      return list.length > this.maxMediaShow ? list.slice(0, this.maxMediaShow) : list
    },
    /** 拼接 OSS 缩略图参数，降低列表解码/加载开销；非 OSS 或已带参数的原样返回 */
    getThumbUrl(url) {
      if (!url) return url
      if (url.includes('x-oss-process')) {
        return url
      }
      // 阿里云 OSS 图片缩放/质量压缩；视频则取首帧作为封面
      if (this.isImage(url)) {
        return url + '?x-oss-process=image/resize,w_160/quality,q_80'
      }
      return url + '?x-oss-process=video/snapshot,t_0,f_jpg,w_160'
    },
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询动态列表 */
    getList () {
      this.loading = true
      pageVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    orderStatusListChange() {
      // this.queryParam.videoState = undefined;
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoContent: undefined,
        videoPid: undefined,
        videoState: undefined,
        address: undefined,
        pubCity: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      if (this.isImage(url)) {
        this.previewUrl = url
        this.previewImageVisible = true
      } else {
        this.previewVideoUrl = url
        this.previewVideoVisible = true
      }
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
      this.previewVideoUrl = ''
    },
    /** 双击视频：新标签页打开视频原地址（浏览器原生播放器，可画中画） */
    openVideoNewTab(url) {
      if (!url) return
      // 缩略图地址可能带 OSS 处理参数，去掉截图参数拿到原始视频地址
      const rawUrl = url.includes('?x-oss-process') ? url.split('?x-oss-process')[0] : url
      window.open(rawUrl, '_blank')
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 审核通过 */
    handleAuditPass (record) {
      const that = this
      this.$confirm({
        title: this.$t('审核通过'),
        content: this.$t('确认审核通过该条动态？'),
        onOk () {
          return updateVideo({ id: record.id, videoState: '3' }).then(() => {
            that.$message.success(that.$t('通用.文本.修改成功'), 3)
            that.getList()
          })
        }
      })
    },
    /** 审核拒绝 */
    handleAuditReject (record) {
      const that = this
      let reason = ''
      this.$confirm({
        title: this.$t('拒绝'),
        content: (h) => h('a-input', {
          props: { placeholder: that.$t('通用.输入.请输入') + that.$t('审核不通过原因'), maxLength: 100 },
          on: { input: (val) => { reason = typeof val === 'string' ? val : (val && val.target ? val.target.value : '') } }
        }),
        onOk () {
          const reasonStr = reason == null ? '' : String(reason)
          if (!reasonStr.trim()) {
            that.$message.warning(that.$t('通用.输入.请输入') + that.$t('审核不通过原因'))
            return Promise.reject()
          }
          return updateVideo({ id: record.id, videoState: '2', reason: reasonStr }).then(() => {
            that.$message.success(that.$t('通用.文本.修改成功'), 3)
            that.getList()
          })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('video/video/export',
            ...that.queryParam
            , `动态_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
